<template>
    <v-row class="mt-0 pa-4 pt-0">
        <v-col class="pt-0">
            <v-form :ref="form">
                <v-select
                    v-model="selectedTouristIndexes"
                    :items="touristListForMultiSelect"
                    :label="$t('tourists')"
                    :rules="[requiredRule('tourists'), quantityItems(+qty)]"
                    item-title="title"
                    item-value="index"
                    clearable
                    density="compact"
                    multiple
                />
            </v-form>
        </v-col>
        <v-divider />
    </v-row>
</template>

<script setup lang="ts">
    const form = ref()
    const {t} = useI18n()

    const selectedExtraServices = defineModel<any[]>({required: true, default: []})

    const props = defineProps<{
        extraService: any
    }>()

    const touristListForMultiSelect = computed(() => {
        return persistentStore.tourists.map((tourist, index) => {
            let title = capitalizeFirstLetter(`${t('passenger', 1)} ${index + 1}`)

            if (tourist.type === 'child') {
                title += ` (${t('child')})`
            }

            if (tourist.firstName || tourist.lastName) {
                title += ` - ${tourist.firstName} ${tourist.lastName}`
            }

            return {title, index}
        })
    })

    const currentExtraServiceForRequest = computed(() => {
        return selectedExtraServices.value.find(item => item.serviceRPH === props.extraService.serviceRPH)
    })

    const qty = computed(() => {
        return currentExtraServiceForRequest.value?.quantity
    })

    const selectedTouristIndexes = computed({
        get: () => currentExtraServiceForRequest.value?.touristIndexes || [],
        set: value => (currentExtraServiceForRequest.value.touristIndexes = value),
    })
</script>
